'use client'

import Link from 'next/link'

type AuthAlternateLinkProps = {
  prompt: string
  href: string
  linkLabel: string
}

export function AuthAlternateLink({ prompt, href, linkLabel }: AuthAlternateLinkProps) {
  return (
    <p className="text-right text-sm text-zinc-500">
      {prompt}{' '}
      <Link href={href} className="font-medium text-zinc-50 underline-offset-4 hover:underline">
        {linkLabel}
      </Link>
    </p>
  )
}
